export { default } from '@shikijs/langs/postcss'
